// @core/api/endpoints/secret/get_crl.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetCRLResponse,
} from '../../../types/secret';

const BASE_PATH = '/secret';

/**
 * Get CRL
 * Returns the Certificate Revocation List (CRL) in PEM or DER format. Public endpoint for certificate validation.
 * @public This endpoint does not require authentication
 */
export async function GetCRL(
  engine_id: string,
  options?: RequestOptions
): Promise<GetCRLResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/engines/:engine_id/pki/crl`;
  requestPath = requestPath.replace(':engine_id', encodeURIComponent(engine_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetCRLResponse>(requestPath, { ...requestOptions });
}
